import { IParcelas } from "../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import RegistrarAcordoSienge from "../RegistrarAcordoSienge";

interface IRenegociacaoSiengeProps extends IParcelas {
    idCaso: number;
    idProduto: number;
    setShow: (show: boolean) => void;
}

export default function RenegociacaoSienge(props: IRenegociacaoSiengeProps) {
    return <RegistrarAcordoSienge {...props} />;
}
